import { Box, styled } from "@mui/material";
import { keyframes } from "@mui/system";

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const DashGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 8px;
  padding-bottom: 32px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const CardCell = styled(Box)`
  min-width: 0;
  animation: ${fadeUp} 0.45s ease both;
  animation-delay: calc(var(--i, 0) * 70ms);

  &[data-span="full"] {
    grid-column: 1 / -1;
  }

  @media (max-width: 900px) {
    &[data-span="full"] {
      grid-column: auto;
    }
  }
`;
